"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Google = createSVGIcon(
  <>
    <path
      fill="#4285F4"
      d="M21.575 12.225a11.6 11.6 0 0 0-.158-1.892H12v3.759h5.392c-.242 1.233-.95 2.275-2 2.983v2.5h3.216c1.884-1.742 2.967-4.308 2.967-7.35"
    />
    <path
      fill="#34A853"
      d="M12 22c2.7 0 4.959-.9 6.608-2.425l-3.216-2.5c-.9.6-2.042.967-3.392.967-2.608 0-4.816-1.759-5.608-4.134H3.075v2.575C4.717 19.75 8.092 22 12 22"
    />
    <path
      fill="#FBBC05"
      d="M6.392 13.908A5.8 5.8 0 0 1 6.075 12c0-.667.117-1.308.317-1.908V7.517H3.075a9.88 9.88 0 0 0 0 8.966z"
    />
    <path
      fill="#EA4335"
      d="M12 5.958c1.475 0 2.792.509 3.834 1.5l2.85-2.85C16.957 2.992 14.7 2 12 2 8.092 2 4.717 4.25 3.075 7.517l3.317 2.575c.792-2.375 3-4.134 5.608-4.134"
    />
  </>,
  "Google",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Google",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  }) // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
